export default {
  install(Vue, { router }) {
    router.addRoutes([
      {
        path: '/authentication',
        name: 'Authentication',
        component: () => import('./Authentication.page.vue'),
        props: true,
        meta: {
          title: 'TITLE__AUTHENTICATION',
          template: 'Auth',
          isAuthentication: false,
        },
      },
    ]);
  },
};
